import { initialState } from './reducer';

export interface IPhonebooksStore {}

export function getInitialPhonebooksStore(): IPhonebooksStore {
  return { ...initialState };
}
